import { observer } from 'mobx-react-lite'
import { MdWifiOff, MdSync } from 'react-icons/md'
import { pwaManager } from '../PwaManager'
import { offlineSyncManager } from '../OfflineSync'
import styles from './OfflineBanner.module.css'

function pendingLabel(count: number): string {
    if (count === 1) return '1 дія'
    if (count >= 2 && count <= 4) return `${count} дії`
    return `${count} дій`
}

export const OfflineBanner = observer(() => {
    const { isOffline } = pwaManager
    const { isSyncing, pendingCount } = offlineSyncManager

    if (!isOffline && !isSyncing) return null

    if (!isOffline && isSyncing) {
        return (
            <div
                className={`${styles['banner']} ${styles['bannerSync']}`}
                role="status"
                aria-live="polite"
            >
                <MdSync className={`${styles['icon']} ${styles['iconSpin']}`} />
                <span className={styles['text']}>Синхронізація…</span>
            </div>
        )
    }

    return (
        <div className={styles['banner']} role="status" aria-live="polite">
            <MdWifiOff className={styles['icon']} />
            <span className={styles['text']}>
                {pendingCount > 0
                    ? `Немає з'єднання. ${pendingLabel(pendingCount)} у черзі.`
                    : "Немає з'єднання з інтернетом. Деякі функції недоступні."}
            </span>
        </div>
    )
})

OfflineBanner.displayName = 'OfflineBanner'
